import type { FC } from 'react';

import { useTileBaseContext } from './TileBaseContext';
import type { LocaleStringObject, ProductHit } from '~/types/algolia';
import { useAppContext } from '~/utilities/context/static/AppContext';
import { localisedData } from '~/utilities/helpers';

type KeysOfType<Obj, Type> = {
  [Prop in keyof Obj]: Obj[Prop] extends Type ? Prop : never;
}[keyof Obj];
type Props = {
  prop: NonNullable<KeysOfType<ProductHit, LocaleStringObject>>;
};

export const LocalizedAlgoliaProp: FC<Props> = ({ prop }) => {
  const { singleProduct } = useTileBaseContext();
  const { lang } = useAppContext();

  return <>{localisedData(singleProduct, singleProduct[prop], lang)}</>;
};
